import { ReactComponent as Undo } from 'assets/icons/icon-undo.svg';

export default Undo;
